import axios from "axios";
import { API_BASE_URL } from "../config/constants";
const cache = new Map();

export const getProduct = async (productId, token) => {
  if (cache.has(productId)) return cache.get(productId);

  const headers = token ? { Authorization: `Bearer ${token}` } : {};
  const res = await axios.get(`${API_BASE_URL}/products/${productId}`, {
    headers,
    withCredentials: true,
  });

  const product = res.data?.data || res.data;
  cache.set(productId, product);
  return product;
};

export const clearProductCache = () => cache.clear();
